import React from "react";

export const IconArrowRight = () => (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 5.5H12" stroke="#004165" strokeWidth="1.5" />
        <path d="M6.98099 10L11.8271 5.5L6.98099 1" stroke="#004165" strokeWidth="1.5" />
    </svg>
);

export const IconPencil = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.6148 3.88582L12.3542 5.14637C12.2257 5.27488 12.0179 5.27488 11.8894 5.14637L8.85424 2.11122C8.72572 1.9827 8.72572 1.77489 8.85424 1.64637L10.1148 0.38583C10.6261 -0.125497 11.4574 -0.125497 11.9714 0.38583L13.6148 2.02919C14.1288 2.54051 14.1288 3.37176 13.6148 3.88582ZM7.77142 2.72919L0.590954 9.90964L0.0112661 13.2319C-0.0680307 13.6803 0.322985 14.0686 0.771423 13.9921L4.09369 13.4096L11.2742 6.22918C11.4027 6.10066 11.4027 5.89285 11.2742 5.76434L8.239 2.72919C8.10775 2.60067 7.89994 2.60067 7.77142 2.72919ZM2.40658 11.594H3.71908V12.5866L1.95541 12.8956L1.10502 12.0452L1.414 10.2815H2.40658V11.594Z"
            fill="#004165"
        />
    </svg>
);
